export type IndexEventsRequest = {
    symbols: string;
    symbology: string;
    side?: string;
    tradeCategories?: string;
};

export const toUid = (r: IndexEventsRequest) =>
    `indexEvents-${r.symbols}-${r.side}-${r.tradeCategories}`;
